export let AVAILABILITY_CATEGORY_ROW = 'availability-category-row';
export let AVAILABILITY_ITEM_ROW = 'availability-item-row';
export let AVAILABILITY_PRODUCT_ROW = 'availability-product-row';
export const CONFLICT_LIST_ITEM = 'conflict-list-item';
export const CLOSE_DIALOG_BUTTON = 'close-dialog-button';
export const NO_CONFLICTS_MESSAGE = 'no-conflicts-message';
export const CONFLICTS_MESSAGE = 'conflicts-message';
export const AVAILABILITY_STATS_CONTAINER = 'availability-stats-container';
export const AVAILABILITY_STATS = 'availability-stats';
